import { render, staticRenderFns } from "./PaperApplyForm.vue?vue&type=template&id=3013a699&scoped=true&"
import script from "./PaperApplyForm.vue?vue&type=script&lang=js&"
export * from "./PaperApplyForm.vue?vue&type=script&lang=js&"
import style0 from "./PaperApplyForm.vue?vue&type=style&index=0&id=3013a699&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3013a699",
  null
  
)

export default component.exports